import React from 'react'
import { Route, Switch } from 'react-router'

// Components
import { routes, useQueryParams, useUserProfile } from '@sketch/modules-common'

// Local Components
import CommunityHeader, {
  CommunityHeaderPlaceholder,
} from '../components/CommunityHeader'

// Pages
import CommunityHubPage from '../containers/CommunityHubPage'
import CommunityListingPage from '../containers/CommunityListingPage'
import CommunitySearchPage from '../containers/CommunitySearchPage'

const CommunityHubRouteSplit = () => {
  const { search } = useQueryParams<'COMMUNITY_CANVAS'>()

  if (search) {
    return <CommunitySearchPage search={search} />
  }

  return <CommunityHubPage />
}

const CommunityView = () => {
  const { data: userData, loading } = useUserProfile()
  const user = userData?.me

  const header = loading ? (
    <CommunityHeaderPlaceholder />
  ) : (
    <CommunityHeader user={user} />
  )

  return (
    <>
      {header}
      <Switch>
        <Route
          path={routes.COMMUNITY_CANVAS.template()}
          exact
          component={CommunityHubRouteSplit}
        />
        <Route
          path={routes.COMMUNITY_CANVAS_LISTING.template()}
          exact
          component={CommunityListingPage}
        />
      </Switch>
    </>
  )
}

export default CommunityView
